// NPM Imports
import React from "react";

// Internal Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

export default function ContentLock({ lock, isDisabled, toggleSectionLock }) {
  if (!lock) {
    return (
      <Tooltip
        placement="top"
        overlay={
          isDisabled
            ? "Blocks converted to placeholder fields cannot be locked"
            : "Lock this block"
        }
        align={{ offset: [0, 3] }}>
        <span
          className={`btn-icon ${isDisabled ? "disabled-lock" : ""}`}
          data-test="documentitems-lock-the-content-btn"
          id="lock-the-content-btn"
          onMouseDown={event => toggleSectionLock(event, true)}
          role="button"
          tabIndex={0}>
          <FontAwesomeIcon icon={["far", "unlock"]} />
        </span>
      </Tooltip>
    );
  }
  return (
    <Tooltip
      placement="top"
      overlay="Unlock this block"
      align={{ offset: [0, 3] }}>
      <span
        className={`btn-icon locked-icon ${isDisabled ? "disabled-lock" : ""}`}
        data-test="documentitems-unlock-the-content-btn"
        id="unlock-the-content-btn"
        onMouseDown={event => toggleSectionLock(event, false)}
        role="button"
        tabIndex={0}>
        <FontAwesomeIcon icon={["far", "lock"]} />
      </span>
    </Tooltip>
  );
}
